import { render, staticRenderFns } from "./property.vue?vue&type=template&id=15aaf4e2&scoped=true"
import script from "./property.vue?vue&type=script&lang=js"
export * from "./property.vue?vue&type=script&lang=js"
import style0 from "./property.vue?vue&type=style&index=0&id=15aaf4e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aaf4e2",
  null
  
)

export default component.exports